
export const vatDeduction = [
    { text: '100% VAT', value: 100 },
    { text: '50% VAT', value: 50 },
    { text: '0% VAT', value: 0 },
];